import { Room } from './Room'

export class Spotlight {
    room!: Room;
    order!: number;
    contentSize!: number;
    spotlightId!: string;
}